// extracted by mini-css-extract-plugin
export default {"container":"lp-z","ratingLayout":"mp-z","ratingLabel":"np-z","nonInteractiveRatingLabel":"op-z"};